/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Media align.
 */
export enum MEDIA_ALIGN {
  /**
   * Content item row media align left
   */
  LEFT = 'left',

  /**
   * Content item row media align right
   */
  RIGHT = 'right',
}

/**
 * Media type.
 */
export enum MEDIA_TYPE {
  /**
   * Content item row media type image
   */
  IMAGE = 'image',

  /**
   * Content item row media type video
   */
  VIDEO = 'video',
}
